// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__8Ws0h","breadcrumbItem":"styles_breadcrumbItem__ARlsY","mainDashboard":"styles_mainDashboard__+7A+A","bgColor":"styles_bgColor__caOQJ"};